import { isBrowser, getClientTypeSync, CLIENT_TYPE, compose, isMMP, isQuickApp, inFrame, isMTYXApp } from '@cap/utils';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import qs from 'query-string';
import _inheritsLoose from '@babel/runtime/helpers/esm/inheritsLoose';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.number.is-nan.js';
import 'core-js/modules/es.number.constructor.js';
import { isUndefined, isFunction } from 'lodash-es';
import Cookies from 'js-cookie';
import 'core-js/modules/es.regexp.constructor.js';
import 'core-js/modules/es.regexp.to-string.js';
import { UAParser } from 'ua-parser-js';
import 'core-js/modules/web.dom-collections.for-each.js';
import axios from 'axios';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import Postmate from 'postmate';

/**
 * C 端用户类型
 */
var USER_TYPE;

(function (USER_TYPE) {
  USER_TYPE["DP"] = "dp";
  USER_TYPE["MT"] = "mt"; // 美团用户
})(USER_TYPE || (USER_TYPE = {}));
/**
 * 运行时环境
 */


var RUNTIME_ENV;

(function (RUNTIME_ENV) {
  RUNTIME_ENV["LOCAL"] = "local";
  RUNTIME_ENV["DEV"] = "dev";
  RUNTIME_ENV["TEST"] = "test";
  RUNTIME_ENV["BETA"] = "beta";
  RUNTIME_ENV["ST"] = "st";
  RUNTIME_ENV["STAGING"] = "staging";
  RUNTIME_ENV["PROD"] = "prod";
  RUNTIME_ENV["PRODUCTION"] = "production";
})(RUNTIME_ENV || (RUNTIME_ENV = {}));
/** 登录场景枚举 */


var ENU_LOGIN_SENCE;

(function (ENU_LOGIN_SENCE) {
  ENU_LOGIN_SENCE["ILOGIN"] = "ilogin";
  ENU_LOGIN_SENCE["PCLOGIN"] = "pclogin";
  ENU_LOGIN_SENCE["ELOGIN"] = "elogin";
})(ENU_LOGIN_SENCE || (ENU_LOGIN_SENCE = {}));
/** 登录的账号体系 */


var ENU_CAP_LOGIN_TYPE;

(function (ENU_CAP_LOGIN_TYPE) {
  ENU_CAP_LOGIN_TYPE["PASSPORT"] = "PASSPORT";
  ENU_CAP_LOGIN_TYPE["EPASSPORT"] = "EPASSPORT";
  ENU_CAP_LOGIN_TYPE["SSO"] = "SSO";
})(ENU_CAP_LOGIN_TYPE || (ENU_CAP_LOGIN_TYPE = {}));
/**
 * 错误码
 */


var ENU_STATUS_CODE;

(function (ENU_STATUS_CODE) {
  ENU_STATUS_CODE[ENU_STATUS_CODE["SUCCESS"] = 0] = "SUCCESS";
  ENU_STATUS_CODE[ENU_STATUS_CODE["PARAMS_ERROR"] = 2] = "PARAMS_ERROR";
  ENU_STATUS_CODE[ENU_STATUS_CODE["TOKEN_INVALID"] = 401] = "TOKEN_INVALID"; // Token非法、错误 
})(ENU_STATUS_CODE || (ENU_STATUS_CODE = {}));

var _ENU_PC_LOGIN_URL, _ENU_H5_LOGIN_URL, _ENU_EPASSPORT_LOGIN_;
/**
 * 设置token的url
 */

var SET_TOKEN_URL = isBrowser ? location.origin + "/cap/account/v2/callback" : '';
/**
 * 融合登录切换纯C端账号登录
 */

var LOGIN_CHANGE_ACCOUNT = "changeAccount";
/**
 * PC 版登录地址
 */

var ENU_PC_LOGIN_URL = (_ENU_PC_LOGIN_URL = {}, _ENU_PC_LOGIN_URL[RUNTIME_ENV.LOCAL] = 'http://passport.fe.test.sankuai.com/useraccount/login', _ENU_PC_LOGIN_URL[RUNTIME_ENV.DEV] = 'http://passport.fe.test.sankuai.com/useraccount/login', _ENU_PC_LOGIN_URL[RUNTIME_ENV.TEST] = 'http://passport.fe.test.sankuai.com/useraccount/login', _ENU_PC_LOGIN_URL[RUNTIME_ENV.ST] = 'https://passport.meituan.com/useraccount/login', _ENU_PC_LOGIN_URL[RUNTIME_ENV.STAGING] = 'https://passport.meituan.com/useraccount/login', _ENU_PC_LOGIN_URL[RUNTIME_ENV.PROD] = 'https://passport.meituan.com/useraccount/login', _ENU_PC_LOGIN_URL[RUNTIME_ENV.PRODUCTION] = 'https://passport.meituan.com/useraccount/login', _ENU_PC_LOGIN_URL);
/**
 * I版登录地址
 */

var ENU_H5_LOGIN_URL = (_ENU_H5_LOGIN_URL = {}, _ENU_H5_LOGIN_URL[RUNTIME_ENV.LOCAL] = 'http://passport.fe.test.sankuai.com/useraccount/ilogin', _ENU_H5_LOGIN_URL[RUNTIME_ENV.DEV] = 'http://passport.fe.test.sankuai.com/useraccount/ilogin', _ENU_H5_LOGIN_URL[RUNTIME_ENV.TEST] = 'http://passport.fe.test.sankuai.com/useraccount/ilogin', _ENU_H5_LOGIN_URL[RUNTIME_ENV.ST] = 'https://passport.meituan.com/useraccount/ilogin', _ENU_H5_LOGIN_URL[RUNTIME_ENV.STAGING] = 'https://passport.meituan.com/useraccount/ilogin', _ENU_H5_LOGIN_URL[RUNTIME_ENV.PROD] = 'https://passport.meituan.com/useraccount/ilogin', _ENU_H5_LOGIN_URL[RUNTIME_ENV.PRODUCTION] = 'https://passport.meituan.com/useraccount/ilogin', _ENU_H5_LOGIN_URL);
/**
* EPassport登录地址
*/

var ENU_EPASSPORT_LOGIN_URL = (_ENU_EPASSPORT_LOGIN_ = {}, _ENU_EPASSPORT_LOGIN_[RUNTIME_ENV.LOCAL] = 'http://fepassport.sjst.test.sankuai.com/portal/login', _ENU_EPASSPORT_LOGIN_[RUNTIME_ENV.DEV] = 'http://fepassport.sjst.dev.sankuai.com/portal/login', _ENU_EPASSPORT_LOGIN_[RUNTIME_ENV.TEST] = 'http://fepassport.sjst.test.sankuai.com/portal/login', _ENU_EPASSPORT_LOGIN_[RUNTIME_ENV.BETA] = 'http://fepassport.sjst.st.sankuai.com/portal/login', _ENU_EPASSPORT_LOGIN_[RUNTIME_ENV.ST] = 'http://fepassport.sjst.st.sankuai.com/portal/login', _ENU_EPASSPORT_LOGIN_[RUNTIME_ENV.STAGING] = 'https://epassport.meituan.com/portal/login', _ENU_EPASSPORT_LOGIN_[RUNTIME_ENV.PROD] = 'https://epassport.meituan.com/portal/login', _ENU_EPASSPORT_LOGIN_[RUNTIME_ENV.PRODUCTION] = 'https://epassport.meituan.com/portal/login', _ENU_EPASSPORT_LOGIN_);

/**
 * 账号适配基类
 */

var Account$2 = /*#__PURE__*/function () {
  function Account() {}

  var _proto = Account.prototype;

  /**
   * 生成登录回调地址
   * @param params LoginOption
   * @returns
   */
  _proto.getTokenUrl = function getTokenUrl(_ref) {
    var backUrl = _ref.backUrl,
        isChangeAccount = _ref.isChangeAccount,
        capLoginType = _ref.capLoginType,
        sameSite = _ref.sameSite,
        bizline = _ref.bizline,
        setLoginTypeToCookie = _ref.setLoginTypeToCookie;
    var login_change_account = isChangeAccount ? LOGIN_CHANGE_ACCOUNT : '';
    var urlObj = qs.parseUrl(backUrl, {
      parseFragmentIdentifier: true
    });
    var targetUrl = qs.stringifyUrl(_objectSpread(_objectSpread({}, urlObj), {}, {
      query: _objectSpread(_objectSpread({}, urlObj.query), {}, {
        login_change_account: login_change_account
      })
    }));
    var query = {
      cap_login_type: capLoginType,
      cap_login_biz: bizline,
      login_type_to_cookie: setLoginTypeToCookie,
      web_url: targetUrl,
      login_change_account: login_change_account
    }; // 强校验，必须为false

    if (sameSite === false) {
      query['same_site'] = '1';
    }

    var setTokenUrl = qs.stringifyUrl({
      url: SET_TOKEN_URL,
      query: query
    });
    return setTokenUrl;
  };

  return Account;
}();

var Account$1 = /*#__PURE__*/function (_BaseAccount) {
  _inheritsLoose(Account, _BaseAccount);

  function Account() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseAccount.call.apply(_BaseAccount, [this].concat(args)) || this;
    _this.className = "Account";
    _this.type = USER_TYPE.MT;
    return _this;
  }

  var _proto = Account.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _qs$parseUrl = qs.parseUrl(window.location.href),
        query = _qs$parseUrl.query;

    return query == null ? void 0 : query.BSID;
  };

  _proto.getLoginUrl = function getLoginUrl(option) {
    var backUrl = option.backUrl,
        env = option.env,
        _option$bgSource = option.bgSource,
        bgSource = _option$bgSource === void 0 ? 4 : _option$bgSource,
        _option$appKey = option.appKey,
        appKey = _option$appKey === void 0 ? "com.sankuai.fspfecap.bizcommon" : _option$appKey,
        _option$feconfig = option.feconfig,
        feconfig = _option$feconfig === void 0 ? "cap-biz-common" : _option$feconfig,
        sameSite = option.sameSite,
        bizline = option.bizline,
        setLoginTypeToCookie = option.setLoginTypeToCookie;
    var setTokenUrl = this.getTokenUrl({
      backUrl: backUrl,
      capLoginType: ENU_CAP_LOGIN_TYPE.EPASSPORT,
      sameSite: sameSite,
      bizline: bizline,
      setLoginTypeToCookie: setLoginTypeToCookie
    }); // bg_source 根据业务通道获取
    // 默认feconfig = cap-biz-common
    // 默认appKey = 'com.sankuai.fspfecap.bizcommon'
    // let loginUrl = `${epassport}?bg_source=${bgSource}&service=${appKey}&continue=${encodeURIComponent(continueUrl)}&feconfig=${feconfig}`;

    var href = qs.stringifyUrl({
      url: ENU_EPASSPORT_LOGIN_URL[env],
      query: {
        bg_source: bgSource,
        service: appKey,
        feconfig: feconfig,
        continue: setTokenUrl
      }
    });
    return href;
  };

  _proto.login = function login(option) {
    var isReplace = option.isReplace;
    var href = this.getLoginUrl(option);
    setTimeout(async function () {
      if (isReplace) {
        location.replace(href);
      } else {
        location.href = href;
      }
    }, 30);
  };

  return Account;
}(Account$2);

/**
 * C端登录通用配置
 * @returns
 */

function loginConfig() {
  var isPC = false;

  var _UAParser = UAParser(navigator.userAgent),
      type = _UAParser.device.type;

  if (!["mobile", "tablet"].includes(type)) {
    isPC = true;
  }

  return {
    risk_platform: isPC ? 1 : 3,
    risk_partner: 359,
    risk_app: 216,
    risk_level: 4
  };
}
/**
 * 获取cookie的域名
 * @returns
 */

function getCookieDomain() {
  var _location = location,
      hostname = _location.hostname;
  var sankuai = '.sankuai.com';
  var meituan = '.meituan.com';

  if (RegExp(sankuai + "$", 'i').test(hostname)) {
    return sankuai;
  }

  if (RegExp(meituan + "$", 'i').test(hostname)) {
    return meituan;
  }

  return hostname;
}
var defaultUrl = isBrowser ? location.href : '';

var Account = /*#__PURE__*/function (_BaseAccount) {
  _inheritsLoose(Account, _BaseAccount);

  function Account() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseAccount.call.apply(_BaseAccount, [this].concat(args)) || this;
    _this.className = "Account";
    _this.type = USER_TYPE.MT;
    return _this;
  }

  var _proto = Account.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _qs$parseUrl = qs.parseUrl(window.location.href),
        query = _qs$parseUrl.query;

    var _ref = query || {},
        mt_c_token = _ref.mt_c_token,
        token = _ref.token;

    var ct = getClientTypeSync(navigator.userAgent);

    if (ct === CLIENT_TYPE.weixinapp) {
      // 微信小程序仅从url中获取token
      return mt_c_token || token;
    } else {
      return mt_c_token || Cookies.get("mt_c_token");
    }
  };

  _proto.getLoginUrl = function getLoginUrl(option) {
    var defaultConfig = loginConfig();

    var _Object$assign = Object.assign({}, defaultConfig, option),
        backUrl = _Object$assign.backUrl,
        env = _Object$assign.env,
        officialAccount = _Object$assign.officialAccount,
        risk_platform = _Object$assign.risk_platform,
        risk_partner = _Object$assign.risk_partner,
        risk_app = _Object$assign.risk_app,
        risk_level = _Object$assign.risk_level,
        bizline = _Object$assign.bizline,
        setLoginTypeToCookie = _Object$assign.setLoginTypeToCookie;

    var clientType = getClientTypeSync(navigator.userAgent);
    var loginQuery = {
      cap_login_biz: bizline,
      login_type_to_cookie: setLoginTypeToCookie,
      risk_partner: risk_partner,
      risk_app: risk_app,
      risk_platform: risk_platform,
      risk_level: risk_level,
      // 在商家端存在token冲突，必须使用settoken中转下
      backurl: backUrl,
      prioritise: [CLIENT_TYPE.weixinapp, CLIENT_TYPE.mmp, CLIENT_TYPE.mtyxapp].includes(clientType) ? 2 : 0 // 微信小程序和美团小程序环境不展示三方登录。

    };
    var loginUrl = ENU_H5_LOGIN_URL[env]; // i版登陆已支持officialAccount,needShowAccountBtn为去掉登陆页面手机号登陆按钮（此按钮无法绑定账号关系）

    if (!isUndefined(officialAccount) && !Number.isNaN(officialAccount)) {
      loginQuery.officialAccount = officialAccount;
      loginQuery.needShowAccountBtn = false;
    }

    var href = qs.stringifyUrl({
      url: loginUrl,
      query: _objectSpread({}, loginQuery)
    });
    return href;
  };

  _proto.login = function login(option) {
    var isReplace = option.isReplace;
    var href = this.getLoginUrl(option);
    setTimeout(async function () {
      if (isReplace) {
        location.replace(href);
      } else {
        location.href = href;
      }
    }, 30);
  };

  return Account;
}(Account$2);

var mw$i = async function mw(_ctx, _next) {
  return new Account();
};

/**
 * 访问容器适配管理
 * 获取登录token
 */

var AdapterManager = /*#__PURE__*/function () {
  function AdapterManager() {
    this.adapters = [];
  }

  var _proto = AdapterManager.prototype;

  /**
   * 注入适配器
   * @param middleware
   * @returns
   */
  _proto.use = function use(adapter) {
    var _this = this;

    if (!Array.isArray(adapter)) {
      adapter = [adapter];
    }

    adapter.forEach(function (adp) {
      if (!isFunction(adp)) {
        throw new Error("适配器必须是一个函数");
      }

      _this.adapters.push(adp);
    });
    return this;
  }
  /**
   * 分发适配器
   */
  ;

  _proto.dispatch = async function dispatch(ctx) {
    var adapters = this.adapters;
    return compose(adapters)(ctx);
  };

  return AdapterManager;
}();

var appendCommonParams = function appendCommonParams(params) {
  var loginTypeToCookie = params.loginTypeToCookie,
      bizline = params.bizline,
      capLoginType = params.capLoginType;
  return {
    cap_login_type: capLoginType,
    cap_login_biz: bizline,
    // 后端服务默认兜底为true。前端仅在为false的时候传递此参数
    login_type_to_cookie: loginTypeToCookie === false ? false : undefined,
    t: Date.now()
  };
};

var ApiManager = /*#__PURE__*/function () {
  function ApiManager(capLoginType) {
    this.http = void 0;
    this.capLoginType = void 0;
    this.capLoginType = capLoginType || '';
    this.http = axios.create({
      baseURL: '/cap/account/v2',
      timeout: 3 * 1000 // 超时时间3秒
      // params: {
      //   cap_login_type: capLoginType || ''
      // }

    });
  }

  var _proto = ApiManager.prototype;

  _proto.setHttpTimeout = function setHttpTimeout(timeout) {
    this.http.defaults.timeout = timeout;
  }
  /**
   * 获取登录用户信息，已登录返回UserInfo，否则返回null
   * @returns
   */
  ;

  _proto.getUserInfo = async function getUserInfo(bizline, loginTypeToCookie) {
    var capLoginType = this.capLoginType;
    console.log(capLoginType);

    var _await$this$http$get = await this.http.get('/userInfo', {
      params: _objectSpread({}, appendCommonParams({
        bizline: bizline,
        capLoginType: capLoginType,
        loginTypeToCookie: loginTypeToCookie
      }))
    }),
        status = _await$this$http$get.status,
        data = _await$this$http$get.data; // @ts-ignore


    if (status === 200 && ENU_STATUS_CODE.SUCCESS === data.code) {
      // @ts-ignore
      return data.data;
    }

    return null;
  }
  /**
   * 判断用户是否登录
   * @returns
   */
  ;

  _proto.checkLogin = async function checkLogin(bizline, loginTypeToCookie) {
    var capLoginType = this.capLoginType;

    var _await$this$http$get2 = await this.http.get('/checkLogin', {
      params: _objectSpread({}, appendCommonParams({
        bizline: bizline,
        capLoginType: capLoginType,
        loginTypeToCookie: loginTypeToCookie
      }))
    }),
        status = _await$this$http$get2.status,
        data = _await$this$http$get2.data; // @ts-ignore


    if (status === 200 && ENU_STATUS_CODE.SUCCESS === data.code && data.data === true) {
      return true;
    }

    return false;
  }
  /**
   * 退出登录
   */
  ;

  _proto.logout = async function logout(bizline, _backUrl, loginTypeToCookie) {
    if (loginTypeToCookie === void 0) {
      loginTypeToCookie = true;
    }

    var capLoginType = this.capLoginType;

    var _await$this$http$get3 = await this.http.get('/logout', {
      params: _objectSpread({}, appendCommonParams({
        bizline: bizline,
        capLoginType: capLoginType,
        loginTypeToCookie: loginTypeToCookie
      }))
    }),
        status = _await$this$http$get3.status,
        data = _await$this$http$get3.data; // @ts-ignore


    if (status === 200 && ENU_STATUS_CODE.SUCCESS === data.code) {
      return true;
    }

    return false;
  }
  /**
   * 登录授权，主要种植用户的登录cookie
   * @returns
   */
  ;

  _proto.auth = async function auth(parmas) {
    var token = parmas.token,
        clientType = parmas.clientType,
        sameSite = parmas.sameSite,
        bizline = parmas.bizline,
        loginTypeToCookie = parmas.loginTypeToCookie;
    var capLoginType = this.capLoginType;

    var _await$this$http$post = await this.http.post('/auth', {
      cap_login_token: token,
      clientType: clientType
    }, {
      params: _objectSpread({
        same_site: sameSite === false ? '1' : undefined
      }, appendCommonParams({
        bizline: bizline,
        capLoginType: capLoginType,
        loginTypeToCookie: loginTypeToCookie
      }))
    }),
        status = _await$this$http$post.status,
        data = _await$this$http$post.data; // @ts-ignore


    if (status === 200 && ENU_STATUS_CODE.SUCCESS === data.code) {
      return true;
    }

    return false;
  };

  return ApiManager;
}();

var owlPrefix = '[AccountSDK]'; // 拦截owl，让其能正常的打到对应的raptor项目

function polyfillOwl() {
  // 非浏览器环境不做处理
  if (!isBrowser) return; // @ts-ignore

  if (!window.Owl) return; // @ts-ignore

  var originalErrorPush = window.Owl.cfgManager.get('onErrorPush'); // @ts-ignore

  window.Owl.config({
    // @ts-ignore
    onErrorPush: function onErrorPush(instance) {
      if (typeof instance.sec_category === 'string' && instance.sec_category.indexOf(owlPrefix) > -1) {
        // 强制修改project，用于上报
        instance.project = 'com.sankuai.fspfecap.dzsdk';
        return instance;
      }

      if (typeof originalErrorPush === 'function') {
        return originalErrorPush.call(this, instance);
      }

      return instance;
    }
  });
}

try {
  polyfillOwl();
} catch (error) {
  console.error(error);
}
/**
 * 上报错误
 * @param name
 * @param error
 * @param opts
 * @returns
 */


function reportError(name, error, opts) {
  if (opts === void 0) {
    opts = {};
  }

  // @ts-ignore
  if (!window.Owl) return; // @ts-ignore

  var Owl = window.Owl;
  var level = opts.level || 'error';

  if (/timeout of (\d)+ms exceeded/.test(error == null ? void 0 : error.message)) {
    level = 'warn';
  }

  Owl.addError({
    name: "" + owlPrefix + name,
    msg: error == null ? void 0 : error.stack
  }, _objectSpread(_objectSpread({}, opts), {}, {
    level: level
  }));
}

var Login = /*#__PURE__*/function () {
  // @ts-ignore
  //@ts-ignore
  function Login(capLoginType) {
    var _bomCtx$href, _bomCtx, _bomCtx2;

    this.userInfo = null;
    this.adapter = void 0;
    this.adapterManager = void 0;
    this.apiManager = void 0;
    this.optsions = void 0;
    this.bizline = void 0;
    this.capLoginType = void 0;
    this.capLoginType = capLoginType;
    this.bizline = '';
    var bomCtx;

    if (isBrowser) {
      var _location = location,
          href = _location.href,
          pathname = _location.pathname,
          origin = _location.origin;
      bomCtx = {
        href: href,
        pathname: pathname,
        origin: origin,
        userAgent: navigator.userAgent
      };
    }

    this.optsions = {
      backUrl: (_bomCtx$href = (_bomCtx = bomCtx) == null ? void 0 : _bomCtx.href) != null ? _bomCtx$href : '',
      env: RUNTIME_ENV.PRODUCTION,
      autoRedirectLogin: true,
      bizline: '',
      setLoginTypeToCookie: true,
      bomCtx: (_bomCtx2 = bomCtx) != null ? _bomCtx2 : {}
    };
    this.adapterManager = new AdapterManager();
    this.apiManager = new ApiManager(this.capLoginType);
  }
  /**
   * SDK 初始化断言
   */


  var _proto = Login.prototype;

  _proto.initAssert = function initAssert() {
    var _this$optsions$bomCtx = this.optsions.bomCtx,
        origin = _this$optsions$bomCtx.origin,
        pathname = _this$optsions$bomCtx.pathname;

    if (!this.adapter) {
      var error = new Error('登录SDK未初始化或初始化未完成');
      reportError('登录SDK初始化未完成adapter为空.p3', error, {
        tags: {
          href: "" + origin + pathname
        }
      });
      throw error;
    }

    if (!this.bizline) {
      var _error = new Error('登录SDK业务方未配置');

      reportError('登录SDK业务方未配置.p3', _error, {
        tags: {
          href: "" + origin + pathname
        }
      });
      throw _error;
    }
  }
  /**
   * 注册适配器中间件
   * @param adapter
   * @returns
   */
  ;

  _proto.use = function use(adapter) {
    this.adapterManager.use(adapter);
    return this;
  }
  /**
   * 服务初始化
   * @param options LoginOption
   * @param options.env RUNTIME_ENV 运行时环境，与美团各环境保持一致（local、dev、test、staging、production）。必填，默认：production
   * @param options.backUrl string 登录或退出后默认的回跳地址。默认：location.href
   * @returns Login
   */
  ;

  _proto.init = async function init(_options) {

    throw new Error('必须实现初始化方法');
  }
  /**
   * 登录处理过程，登录后重定向到落地页（backUrl）
   * @param options LoginOption 每次调用可以重新默认的配置
   */
  ;

  _proto.login = function login(options) {
    this.initAssert();
    var href = this.optsions.bomCtx.href;
    var opts = options != null ? options : {
      backUrl: href
    };

    var parmas = _objectSpread(_objectSpread({}, this.optsions), opts);

    return this.adapter.login(parmas);
  }
  /**
  * 获取登录地址
  * @param options LoginOption 每次调用可以重新默认的配置
  */
  ;

  _proto.getLoginUrl = function getLoginUrl(options) {
    this.initAssert();
    var href = this.optsions.bomCtx.href;
    var opts = options != null ? options : {
      backUrl: href
    };

    var parmas = _objectSpread(_objectSpread({}, this.optsions), opts);

    return this.adapter.getLoginUrl(parmas);
  }
  /**
   * 获取登录用户的基本信息
   * @param force Boolean 强制调用接口获取用户信息
   * @returns Promise<UserInfo | null>
   */
  ;

  _proto.getUserInfo = async function getUserInfo(force) {
    if (force === void 0) {
      force = false;
    }

    this.initAssert();
    var adapter = this.adapter,
        userInfo = this.userInfo,
        apiManager = this.apiManager,
        setLoginTypeToCookie = this.optsions.setLoginTypeToCookie;

    try {
      if (!force && userInfo) {
        return userInfo;
      } // @ts-ignore


      if (isFunction(adapter.getUserInfo)) {
        // @ts-ignore
        this.userInfo = await adapter.getUserInfo();
      } else {
        this.userInfo = await apiManager.getUserInfo(this.bizline, setLoginTypeToCookie);
      }

      return this.userInfo;
    } catch (error) {
      var _this$optsions$bomCtx2 = this.optsions.bomCtx,
          origin = _this$optsions$bomCtx2.origin,
          pathname = _this$optsions$bomCtx2.pathname;
      reportError('获取用户信息出错.p3', error, {
        tags: {
          href: "" + origin + pathname
        }
      });
      console.warn(error);
    }

    return null;
  }
  /**
   * 校验用户是否登录
   * @returns Boolean
   */
  ;

  _proto.checkLogin = async function checkLogin() {
    this.initAssert();
    var _this$optsions = this.optsions,
        setLoginTypeToCookie = _this$optsions.setLoginTypeToCookie,
        _this$optsions$bomCtx3 = _this$optsions.bomCtx;
    _this$optsions$bomCtx3 = _this$optsions$bomCtx3 === void 0 ? {} : _this$optsions$bomCtx3;
    var origin = _this$optsions$bomCtx3.origin,
        pathname = _this$optsions$bomCtx3.pathname,
        bizline = this.bizline;

    try {
      return this.apiManager.checkLogin(bizline, setLoginTypeToCookie);
    } catch (error) {
      reportError('判断用户是否登录出错.p3', error, {
        tags: {
          href: "" + origin + pathname
        }
      });
      console.warn(error);
    }

    return false;
  }
  /**
   * 退出登录，跳转到backUrl
   * @param options
   */
  ;

  _proto.logout = async function logout(options) {
    if (options === void 0) {
      options = {};
    }

    this.initAssert();

    var opts = _objectSpread(_objectSpread({}, this.optsions), options);

    var setLoginTypeToCookie = opts.setLoginTypeToCookie,
        backUrl = opts.backUrl,
        autoRedirectLogin = opts.autoRedirectLogin;

    try {
      var logoutStatus = await this.apiManager.logout(this.bizline, backUrl, setLoginTypeToCookie); // @ts-ignore

      if (isFunction(this.adapter.logout)) {
        // @ts-ignore
        await this.adapter.logout();
      }

      if (autoRedirectLogin === false) {
        return logoutStatus;
      }

      var urlObj = qs.parseUrl(backUrl, {
        parseFragmentIdentifier: true
      });
      var targetUrl = qs.stringifyUrl(_objectSpread(_objectSpread({}, urlObj), {}, {
        query: _objectSpread(_objectSpread({}, urlObj.query), {}, {
          _t: Date.now()
        })
      }));
      setTimeout(function () {
        window.location.href = targetUrl;
      }, 50);
    } catch (error) {
      var _this$optsions$bomCtx4 = this.optsions.bomCtx,
          origin = _this$optsions$bomCtx4.origin,
          pathname = _this$optsions$bomCtx4.pathname;
      reportError('退出登录出错.p3', error, {
        tags: {
          href: "" + origin + pathname
        }
      });
      console.warn(error);
    }
  };

  return Login;
}();

function loadScript(src) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = src;
    script.charset = 'utf-8';

    script.onload = script.onerror = function onload(evt) {
      script.onload = script.onerror = null;

      if (evt) {
        // @ts-ignore
        evt.type === 'error' ? reject(evt) : resolve(evt);
      }
    };

    document.head.appendChild(script);
  });
}
/**
 * 异步加载knb
 */

function loadKNB() {
  // @ts-ignore
  if (window.KNB) return window.KNB;
  var sdk = "//s0.meituan.net/bs/knb/v1.8.3/knb.js"; // @ts-ignore

  if (window.BExt) {
    sdk = '//s0.meituan.net/bs/knb/v1.7.1/knb.js';
  } // @ts-ignore


  return loadScript(sdk).then(function () {
    return window.KNB;
  });
}

/**
 * 点评适配
 */

var MeiTuan = /*#__PURE__*/function (_Account) {
  _inheritsLoose(MeiTuan, _Account);

  function MeiTuan() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Account.call.apply(_Account, [this].concat(args)) || this;
    _this.className = 'MeiTuan';
    return _this;
  }

  var _proto = MeiTuan.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _this2 = this;

    var KNB = await loadKNB();
    return new Promise(function (reslove, reject) {
      KNB.ready(function () {
        KNB.getUserInfo({
          success: function success(user) {
            console.log(_this2.className + " native user with passport: ", JSON.stringify(user));
            var token = user.token,
                userId = user.userId;

            if (userId) {
              return reslove(token);
            }

            return reject(null);
          },
          fail: function fail() {
            reject(null);
          }
        });
      });
    });
  };

  _proto.login = async function login(option) {
    var backUrl = option.backUrl,
        _option$isReload = option.isReload,
        isReload = _option$isReload === void 0 ? true : _option$isReload;
    var KNB = await loadKNB(); // 未获取到用户信息，跳转到登录页面

    return new Promise(function (reslove, reject) {
      KNB.ready(function () {
        KNB.login({
          success: function success(user) {
            if (isReload) {
              var userId = user.userId,
                  token = user.token; // 统一增加fromSource=ilogin，用于登录后做后续操作

              var urlObj = qs.parseUrl(backUrl || window.location.href);

              var parseUrlObj = _objectSpread(_objectSpread({}, urlObj), {}, {
                query: _objectSpread(_objectSpread({}, urlObj.query), {}, {
                  fromSource: ENU_LOGIN_SENCE.ILOGIN,
                  // 登录成功后把userId和token放在页面url上
                  userId: userId,
                  mt_c_token: token,
                  _t: Date.now()
                })
              });

              window.location.replace(qs.stringifyUrl(parseUrlObj));
            } else {
              reslove(user);
            }
          },
          fail: function fail(err) {
            reject(err);
          }
        });
      });
    });
  };

  _proto.logout = async function logout() {
    var KNB = await loadKNB(); // 未获取到用户信息，跳转到登录页面

    return new Promise(function (reslove, reject) {
      KNB.ready(function () {
        KNB.logout({
          //@ts-ignore
          reason: 10000,
          success: function success() {
            reslove(true);
          },
          fail: function fail(err) {
            reject(err);
          }
        });
      });
    });
  };

  return MeiTuan;
}(Account);

var mw$h = async function mw(ctx, next) {
  var ua = ctx.ua,
      clientType = ctx.clientType; // c端登录受限容器

  var hostBlacklist = [CLIENT_TYPE.daxiang, CLIENT_TYPE.mwaimai, CLIENT_TYPE.mhotel, CLIENT_TYPE.ecomapp, CLIENT_TYPE.erpbosspro];

  if (!hostBlacklist.includes(clientType) && !isMMP(ua) && !isQuickApp(ua) && [CLIENT_TYPE.meituan, CLIENT_TYPE.mtliveanchor].includes(clientType)) {
    return new MeiTuan();
  }

  return next();
};

/**
 * 点评适配
 */

var Dianping = /*#__PURE__*/function (_MeiTuan) {
  _inheritsLoose(Dianping, _MeiTuan);

  function Dianping() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _MeiTuan.call.apply(_MeiTuan, [this].concat(args)) || this;
    _this.className = 'Dianping';
    _this.type = USER_TYPE.DP;
    return _this;
  }

  var _proto = Dianping.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _await$_MeiTuan$proto;

    var token = (_await$_MeiTuan$proto = await _MeiTuan.prototype.resloveToken.call(this)) != null ? _await$_MeiTuan$proto : Cookies.get('dper');
    return token;
  };

  return Dianping;
}(MeiTuan);

var mw$g = async function mw(ctx, next) {
  var clientType = ctx.clientType;

  if (CLIENT_TYPE.dianping === clientType) {
    return new Dianping();
  }

  return next();
};

/**
 * 买菜app适配
 */

var Maicai = /*#__PURE__*/function (_MeiTuan) {
  _inheritsLoose(Maicai, _MeiTuan);

  function Maicai() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _MeiTuan.call.apply(_MeiTuan, [this].concat(args)) || this;
    _this.className = 'Maicai';
    return _this;
  }

  var _proto = Maicai.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _qs$parseUrl = qs.parseUrl(window.location.href),
        query = _qs$parseUrl.query;

    return (query == null ? void 0 : query.mt_c_token) || (query == null ? void 0 : query.token);
  };

  return Maicai;
}(MeiTuan);

var mw$f = async function mw(ctx, next) {
  var clientType = ctx.clientType;

  if (CLIENT_TYPE.maicai === clientType) {
    return new Maicai();
  }

  return next();
};

/**
 * 点评适配
 */

var PC = /*#__PURE__*/function (_Account) {
  _inheritsLoose(PC, _Account);

  function PC() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Account.call.apply(_Account, [this].concat(args)) || this;
    _this.className = "PC";
    return _this;
  }

  var _proto = PC.prototype;

  _proto.getLoginUrl = function getLoginUrl(option) {
    var defaultConfig = loginConfig();

    var _Object$assign = Object.assign({}, defaultConfig, option),
        backUrl = _Object$assign.backUrl,
        isChangeAccount = _Object$assign.isChangeAccount,
        env = _Object$assign.env,
        sameSite = _Object$assign.sameSite,
        risk_platform = _Object$assign.risk_platform,
        risk_partner = _Object$assign.risk_partner,
        bizline = _Object$assign.bizline,
        setLoginTypeToCookie = _Object$assign.setLoginTypeToCookie;

    var setTokenUrl = this.getTokenUrl({
      backUrl: backUrl,
      isChangeAccount: isChangeAccount,
      capLoginType: ENU_CAP_LOGIN_TYPE.PASSPORT,
      sameSite: sameSite,
      bizline: bizline,
      setLoginTypeToCookie: setLoginTypeToCookie
    });
    var href = qs.stringifyUrl({
      url: ENU_PC_LOGIN_URL[env],
      query: {
        continue: setTokenUrl,
        risk_platform: risk_platform,
        risk_partner: risk_partner
      }
    });
    return href;
  };

  _proto.login = function login(option) {
    var isReplace = option.isReplace;
    var href = this.getLoginUrl(option);
    setTimeout(async function () {
      if (isReplace) {
        location.replace(href);
      } else {
        location.href = href;
      }
    }, 30);
  };

  return PC;
}(Account);

var mw$e = async function mw(ctx, next) {
  var ua = ctx.ua;

  var _UAParser = UAParser(ua),
      type = _UAParser.device.type;

  if (!["mobile", "tablet"].includes(type)) {
    return new PC();
  }

  return next();
};

/**
 * 两秒拒绝处理
 * @returns
 */

function autoReject$1() {
  return new Promise(function (_, reject) {
    var timeOut = 2000;
    setTimeout(function () {
      return reject(new Error("reslove passport token time out of " + timeOut + " with postmessage"));
    }, timeOut);
  });
}

var IFramePostMessageWithPassport = /*#__PURE__*/function (_PC) {
  _inheritsLoose(IFramePostMessageWithPassport, _PC);

  function IFramePostMessageWithPassport() {
    var _this;

    _this = _PC.call(this) || this;
    _this.className = 'IframePostMessageWithPassport';
    _this.promise = void 0;
    _this.promise = new Promise(function (reslove) {
      Postmate.debug = true;
      new Postmate.Model({
        /**
         * 设置美团C端Passport token
         * @param token
         */
        setCToken: function setCToken(token) {
          reslove(token);
        },

        /**
         * 设置点评账号体系的 token
         * @param token
         */
        setDPToken: function setDPToken(token) {
          reslove(token);
        }
      });
    });
    return _this;
  }

  var _proto = IFramePostMessageWithPassport.prototype;

  _proto.resloveToken = async function resloveToken() {
    try {
      var token = await Promise.race([this.promise, autoReject$1()]);
      console.log(this.className + " reslove token: " + token);
      return token;
    } catch (error) {
      console.error(error);
      return _PC.prototype.resloveToken.call(this);
    }
  };

  return IFramePostMessageWithPassport;
}(PC);

var mw$d = async function mw(ctx, next) {
  var clientType = ctx.clientType;

  if (CLIENT_TYPE.unknown === clientType && inFrame()) {
    return new IFramePostMessageWithPassport();
  }

  return next();
};

/**
 * 外卖C端App
 */

var DeliveryAndCrowdsource = /*#__PURE__*/function (_MeiTuan) {
  _inheritsLoose(DeliveryAndCrowdsource, _MeiTuan);

  function DeliveryAndCrowdsource() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _MeiTuan.call.apply(_MeiTuan, [this].concat(args)) || this;
    _this.className = 'DeliveryAndCrowdsource';
    return _this;
  }

  var _proto = DeliveryAndCrowdsource.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _qs$parseUrl = qs.parseUrl(window.location.href),
        query = _qs$parseUrl.query;

    return query == null ? void 0 : query.mtUserToken;
  };

  return DeliveryAndCrowdsource;
}(MeiTuan);

var mw$c = async function mw(ctx, next) {
  var clientType = ctx.clientType;

  if ([CLIENT_TYPE.ioscrowdsource, CLIENT_TYPE.iosdelivery, CLIENT_TYPE.crowdsource, CLIENT_TYPE.delivery].includes(clientType)) {
    return new DeliveryAndCrowdsource();
  }

  return next();
};

/**
 * 外卖C端App
 */

var WaiMai = /*#__PURE__*/function (_MeiTuan) {
  _inheritsLoose(WaiMai, _MeiTuan);

  function WaiMai() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _MeiTuan.call.apply(_MeiTuan, [this].concat(args)) || this;
    _this.className = 'WaiMai';
    return _this;
  }

  var _proto = WaiMai.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _qs$parseUrl = qs.parseUrl(window.location.href),
        query = _qs$parseUrl.query;

    var token = (query == null ? void 0 : query.wm_logintoken) || (query == null ? void 0 : query.token) || (query == null ? void 0 : query.mt_c_token);

    if (!token) {
      return _MeiTuan.prototype.resloveToken.call(this);
    }

    return token;
  };

  return WaiMai;
}(MeiTuan);

var mw$b = async function mw(ctx, next) {
  var clientType = ctx.clientType;

  if (CLIENT_TYPE.waimai === clientType) {
    return new WaiMai();
  }

  return next();
};

/**
 * 微信和美团小程序
 */

var MiniApp = /*#__PURE__*/function (_Account) {
  _inheritsLoose(MiniApp, _Account);

  function MiniApp() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Account.call.apply(_Account, [this].concat(args)) || this;
    _this.className = 'MiniApp';
    return _this;
  }

  var _proto = MiniApp.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _qs$parseUrl = qs.parseUrl(window.location.href),
        query = _qs$parseUrl.query;

    var token = await _Account.prototype.resloveToken.call(this);
    token = token || (query == null ? void 0 : query.token);
    return token;
  };

  _proto.login = function login(option) {
    var backUrl = option.backUrl,
        miniAppLoginUrl = option.miniAppLoginUrl; // 无小程序登录地址，继续使用h5登录

    if (!miniAppLoginUrl) {
      return _Account.prototype.login.call(this, option);
    }

    var loginQuery = {
      backurl: backUrl
    };
    var loginUrl = miniAppLoginUrl;
    var href = qs.stringifyUrl({
      url: loginUrl,
      query: _objectSpread({}, loginQuery)
    }); // @ts-ignore

    if (window.wx) {
      // 跳转到微信登录页面
      // @ts-ignore
      window.wx.miniProgram.navigateTo({
        url: href
      });
    } else {
      throw new Error("缺少wxjssdk");
    }
  };

  return MiniApp;
}(Account);

var mw$a = async function mw(ctx, next) {
  var clientType = ctx.clientType,
      ua = ctx.ua;

  if (CLIENT_TYPE.weixinapp === clientType || CLIENT_TYPE.mmp === clientType && !isMTYXApp(ua)) {
    return new MiniApp();
  }

  return next();
};

/**
 * 美团优选适配
 */

var MTYouXuanApp = /*#__PURE__*/function (_MeiTuan) {
  _inheritsLoose(MTYouXuanApp, _MeiTuan);

  // @ts-ignore
  function MTYouXuanApp() {
    var _this;

    _this = _MeiTuan.call(this) || this;
    _this.className = 'MTYouXuanApp';
    _this.account = void 0;
    _this.inMMP = void 0;
    _this.inMMP = isMMP(navigator.userAgent);
    _this.account = new Account();
    return _this;
  }

  var _proto = MTYouXuanApp.prototype;

  _proto.resloveToken = async function resloveToken() {
    // 兼容优选App的MMP webview
    if (this.inMMP) {
      var token = await this.account.resloveToken();

      var _qs$parseUrl = qs.parseUrl(window.location.href),
          query = _qs$parseUrl.query;

      token = token || (query == null ? void 0 : query.token);
      return token;
    }

    var KNB = await loadKNB();
    return new Promise(function (reslove, reject) {
      KNB.ready(function () {
        KNB.getUserInfo({
          success: function success(user) {
            var token = user.token,
                userId = user.userId;

            if (userId) {
              return reslove(token);
            }

            return reject(null);
          },
          fail: function fail() {
            reject(null);
          }
        });
      });
    });
  };

  _proto.login = function login(option) {
    if (this.inMMP) {
      return Promise.resolve(this.account.login(option));
    }

    return _MeiTuan.prototype.login.call(this, option);
  };

  return MTYouXuanApp;
}(MeiTuan);

var mw$9 = async function mw(ctx, next) {
  var clientType = ctx.clientType; // 美团优选titans容器，mmp容器直接走默认的h5登录

  if (CLIENT_TYPE.mtyxapp === clientType) {
    return new MTYouXuanApp();
  }

  return next();
};

/**
 * SSR
 */

var SSR$1 = /*#__PURE__*/function (_Account) {
  _inheritsLoose(SSR, _Account);

  function SSR() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Account.call.apply(_Account, [this].concat(args)) || this;
    _this.className = "SSR";
    return _this;
  }

  var _proto = SSR.prototype;

  _proto.resloveToken = async function resloveToken() {
    console.log('resloveToken 暂不支持 Node 环境');
    return;
  };

  _proto.getLoginUrl = function getLoginUrl(_option) {
    console.log('getLoginUrl 暂不支持 Node 环境');
    return '';
  };

  _proto.login = function login(_option) {
    console.log('Node 环境不需要登录');
  };

  return SSR;
}(Account);

var mw$8 = async function mw(_ctx, next) {
  if (!isBrowser) {
    return new SSR$1();
  }

  return next();
};

var defaultAdapters$1 = [mw$8, mw$g, mw$c, mw$b, mw$9, mw$f, mw$h, mw$d, mw$e, mw$a, mw$i];

var ILogin = /*#__PURE__*/function (_Login) {
  _inheritsLoose(ILogin, _Login);

  function ILogin() {
    var _this;

    _this = _Login.call(this, ENU_CAP_LOGIN_TYPE.PASSPORT) || this; // 初始化默认适配对象

    _this.adapter = new Account();

    _this.adapterManager.use(defaultAdapters$1);

    return _this;
  }
  /**
  * 服务初始化
  * @param options LoginOption
  * @param options.env RUNTIME_ENV 运行时环境，与美团各环境保持一致（local、dev、test、staging、production）。必填，默认：production
  * @param options.backUrl string 登录或退出后默认的回跳地址。默认：location.href
  * @param isChangeAccount boolean 是否切换账号登录。默认：false
  * @param isReplace boolean 登录后回跳是否replace历史栈（location.replace(backUrl)）。默认：false，采用location.href 方式跳转
  * @param isReload boolean 团App下登录后是否强制重新加载。默认：true
  * @returns ILogin
  */


  var _proto = ILogin.prototype;

  _proto.init = async function init(options) {
    var _this2 = this;

    if (options === void 0) {
      options = {};
    }

    this.optsions = _objectSpread(_objectSpread({}, this.optsions), options);
    var _this$optsions = this.optsions,
        bizline = _this$optsions.bizline,
        sameSite = _this$optsions.sameSite,
        setLoginTypeToCookie = _this$optsions.setLoginTypeToCookie,
        apiTimeout = _this$optsions.apiTimeout,
        bomCtx = _this$optsions.bomCtx;
    this.bizline = bizline;
    var ua = bomCtx == null ? void 0 : bomCtx.userAgent;
    var clientType = getClientTypeSync(ua);
    var ctx = {
      ua: ua,
      clientType: clientType
    };
    var cookieOption = {};

    if (sameSite === false) {
      cookieOption.sameSite = 'None';
      cookieOption.secure = true;
    } // 配置了api超时时间的需要使用项目配置的超时时间配置


    if (apiTimeout) {
      this.apiManager.setHttpTimeout(apiTimeout);
    } // 种植登录类型


    setLoginTypeToCookie && Cookies.set('cap_login_type', this.capLoginType, cookieOption);
    var adapter = this.adapter = await this.adapterManager.dispatch(ctx);

    try {
      var token = await adapter.resloveToken();

      if (token) {
        Cookies.set('mt_c_token', token, _objectSpread(_objectSpread({}, cookieOption), {}, {
          domain: getCookieDomain()
        }));
      }

      await this.apiManager.auth({
        bizline: bizline,
        token: token,
        clientType: clientType,
        sameSite: options.sameSite,
        loginTypeToCookie: setLoginTypeToCookie
      }).then(function (ret) {
        if (ret) {
          return _this2.getUserInfo(true);
        }

        return null;
      });
    } catch (error) {
      isBrowser && reportError('C端登录sdk初始化失败.p3', error, {
        tags: {
          clientType: clientType,
          href: "" + location.origin + location.pathname
        }
      });
      console.error('ilogin init error.', error);
    }

    return this;
  }
  /**
   * 获取登录用户的基本信息
   * @param force Boolean 强制调用接口获取用户信息
   * @returns Promise<UserInfo | null>
   */
  ;

  _proto.getUserInfo = async function getUserInfo(force) {
    if (force === void 0) {
      force = false;
    }

    var userInfo = await _Login.prototype.getUserInfo.call(this, force); // 兼容旧的处理逻辑

    if (userInfo != null && userInfo.userId) {
      Cookies.set('passport_userid', userInfo.userId);
      Cookies.set('userId', userInfo.userId);
    }

    return userInfo;
  };

  return ILogin;
}(Login);

var iLogin = new ILogin();

/**
 * 美团商家App（开店宝）
 */

var MeiTuanMerchant = /*#__PURE__*/function (_Account) {
  _inheritsLoose(MeiTuanMerchant, _Account);

  function MeiTuanMerchant() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Account.call.apply(_Account, [this].concat(args)) || this;
    _this.className = 'Merchant';
    return _this;
  }

  var _proto = MeiTuanMerchant.prototype;

  _proto.resloveToken = async function resloveToken() {
    var KNB = await loadKNB();
    return new Promise(function (reslove, reject) {
      KNB.ready(function () {
        KNB.getUserInfo({
          success: function success(user) {
            var token = user.token,
                userId = user.userId;

            if (userId) {
              return reslove(token);
            }

            return reject(null);
          },
          fail: function fail() {
            var _qs$parseUrl = qs.parseUrl(window.location.href),
                query = _qs$parseUrl.query;

            var _ref = query || {},
                bizlogintoken = _ref.bizlogintoken;

            if (bizlogintoken) {
              return reslove(bizlogintoken);
            }

            reject(null);
          }
        });
      });
    });
  };

  _proto.logout = async function logout() {
    var KNB = await loadKNB(); // 未获取到用户信息，跳转到登录页面

    return new Promise(function (reslove) {
      KNB.ready(function () {
        KNB.logout({
          //@ts-ignore
          reason: 10000,
          success: function success() {
            reslove(true);
          }
        });
      });
    });
  };

  return MeiTuanMerchant;
}(Account$1);

var mw$7 = async function mw(ctx, next) {
  var ua = ctx.ua,
      clientType = ctx.clientType;

  if (!isMMP(ua) && !isQuickApp(ua) && CLIENT_TYPE.ecomapp === clientType) {
    return new MeiTuanMerchant();
  }

  return next();
};

/**
 * 点评管家（已下线）
 */

var DPMerchant = /*#__PURE__*/function (_MeiTuanMerchant) {
  _inheritsLoose(DPMerchant, _MeiTuanMerchant);

  function DPMerchant() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _MeiTuanMerchant.call.apply(_MeiTuanMerchant, [this].concat(args)) || this;
    _this.className = 'DPMerchant';
    _this.type = USER_TYPE.DP;
    return _this;
  }

  var _proto = DPMerchant.prototype;

  _proto.resloveToken = async function resloveToken() {
    var token = Cookies.get('edper');
    return token;
  };

  return DPMerchant;
}(MeiTuanMerchant);

var mw$6 = async function mw(ctx, next) {
  var clientType = ctx.clientType;

  if (CLIENT_TYPE.dpmerchant === clientType) {
    return new DPMerchant();
  }

  return next();
};

/**
 * 门票商家App
 */

var MenPiao = /*#__PURE__*/function (_MeiTuanMerchant) {
  _inheritsLoose(MenPiao, _MeiTuanMerchant);

  function MenPiao() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _MeiTuanMerchant.call.apply(_MeiTuanMerchant, [this].concat(args)) || this;
    _this.className = 'MenPiao';
    return _this;
  }

  var _proto = MenPiao.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _qs$parseUrl = qs.parseUrl(window.location.href),
        query = _qs$parseUrl.query;

    var _ref = query || {},
        ly_bsid = _ref.ly_bsid,
        token = _ref.token; // https://km.sankuai.com/page/531836420


    return token || ly_bsid;
  };

  return MenPiao;
}(MeiTuanMerchant);

var mw$5 = async function mw(ctx, next) {
  var clientType = ctx.clientType;

  if (CLIENT_TYPE.tripbiz === clientType) {
    return new MenPiao();
  }

  return next();
};

/**
 * 酒店商家App
 */

var MeiJiu = /*#__PURE__*/function (_MeiTuanMerchant) {
  _inheritsLoose(MeiJiu, _MeiTuanMerchant);

  function MeiJiu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _MeiTuanMerchant.call.apply(_MeiTuanMerchant, [this].concat(args)) || this;
    _this.className = 'MeiJiu';
    return _this;
  }

  var _proto = MeiJiu.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _qs$parseUrl = qs.parseUrl(window.location.href),
        query = _qs$parseUrl.query;

    var _ref = query || {},
        bizLoginToken = _ref.bizLoginToken,
        token = _ref.token; // 优先获取 bizLoginToken ，再获取 token。android 下两个值都存在，ios下只有 token


    return bizLoginToken || token;
  };

  return MeiJiu;
}(MeiTuanMerchant);

var mw$4 = async function mw(ctx, next) {
  var clientType = ctx.clientType;

  if (CLIENT_TYPE.mhotel === clientType) {
    return new MeiJiu();
  }

  return next();
};

/**
 * 外卖商家App
 */

var WaiMaiMerchant = /*#__PURE__*/function (_MeiTuanMerchant) {
  _inheritsLoose(WaiMaiMerchant, _MeiTuanMerchant);

  function WaiMaiMerchant() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _MeiTuanMerchant.call.apply(_MeiTuanMerchant, [this].concat(args)) || this;
    _this.className = 'WaiMaiMerchant';
    return _this;
  }

  var _proto = WaiMaiMerchant.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _this2 = this;

    var KNB = await loadKNB();

    var getBsid = function getBsid() {
      var _qs$parseUrl = qs.parseUrl(window.location.href),
          query = _qs$parseUrl.query;

      return (query == null ? void 0 : query.bsid) || (query == null ? void 0 : query.BSID);
    };

    return new Promise(function (reslove) {
      KNB.ready(function () {
        KNB.use('waimaibiz.getAccountInfo', {
          success: function success(result) {
            var _user;

            console.log('waimaibiz.getAccountInfo', result);
            var user = null;

            try {
              if (typeof result.data === 'string') {
                user = JSON.parse(result.data);
              } else {
                user = result.data;
              }
            } catch (error) {
              console.error(_this2.className + " resloveToken error");
            } // 桥获取不到，再从url中获取一次


            var bsid = ((_user = user) == null ? void 0 : _user.bsid) || getBsid();

            if (bsid) {
              return reslove(bsid);
            }

            return reslove(undefined);
          },
          fail: function fail(err) {
            console.warn('waimaibiz.getAccountInfo.error', err); // 从url中获取一次

            var bsid = getBsid();

            if (bsid) {
              return reslove(bsid);
            }

            reslove(undefined);
          }
        });
      });
    });
  };

  _proto.logout = async function logout() {
    // 不退出native登录
    return true;
  };

  return WaiMaiMerchant;
}(MeiTuanMerchant);

var mw$3 = async function mw(ctx, next) {
  var clientType = ctx.clientType;

  if (CLIENT_TYPE.mwaimai === clientType) {
    return new WaiMaiMerchant();
  }

  return next();
};

/**
 * 两秒拒绝处理
 * @returns
 */

function autoReject() {
  return new Promise(function (_, reject) {
    var timeOut = 2000;
    setTimeout(function () {
      return reject(new Error("reslove ep token time out of " + timeOut + " with postmessage"));
    }, timeOut);
  });
}

var IFramePostMessageWithEP = /*#__PURE__*/function (_Account) {
  _inheritsLoose(IFramePostMessageWithEP, _Account);

  function IFramePostMessageWithEP() {
    var _this;

    _this = _Account.call(this) || this;
    _this.className = 'IFramePostMessageWithEP';
    _this.promise = void 0;
    _this.promise = new Promise(function (reslove) {
      Postmate.debug = true;
      new Postmate.Model({
        setEPToken: function setEPToken(token) {
          reslove(token);
        }
      });
    });
    return _this;
  }

  var _proto = IFramePostMessageWithEP.prototype;

  _proto.resloveToken = async function resloveToken() {
    try {
      var token = await Promise.race([this.promise, autoReject()]);
      console.log(this.className + " reslove token: " + token);
      return token;
    } catch (error) {
      console.error(error);
      return _Account.prototype.resloveToken.call(this);
    }
  };

  return IFramePostMessageWithEP;
}(Account$1);

var mw$2 = async function mw(ctx, next) {
  var clientType = ctx.clientType;

  if (CLIENT_TYPE.unknown === clientType && inFrame()) {
    return new IFramePostMessageWithEP();
  }

  return next();
};

/**
 * 美团直播助手 App
 */

var MTLiveAnchor = /*#__PURE__*/function (_MeiTuanMerchant) {
  _inheritsLoose(MTLiveAnchor, _MeiTuanMerchant);

  function MTLiveAnchor() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _MeiTuanMerchant.call.apply(_MeiTuanMerchant, [this].concat(args)) || this;
    _this.className = 'MTLiveAnchor';
    return _this;
  }

  var _proto = MTLiveAnchor.prototype;

  _proto.resloveToken = async function resloveToken() {
    var _this2 = this;

    var KNB = await loadKNB();

    var getBsid = function getBsid() {
      var _qs$parseUrl = qs.parseUrl(window.location.href),
          query = _qs$parseUrl.query;

      return (query == null ? void 0 : query.bsid) || (query == null ? void 0 : query.BSID);
    };

    return new Promise(function (reslove, reject) {
      KNB.ready(function () {
        KNB.getUserInfo({
          success: function success(user) {
            console.log(_this2.className + " native user: ", JSON.stringify(user));
            var token = user.token,
                userId = user.userId;

            if (userId) {
              return reslove(token);
            }

            return reject(null);
          },
          fail: function fail() {
            var token = getBsid();

            if (token) {
              return reslove(token);
            }

            reject(null);
          }
        });
      });
    });
  };

  _proto.logout = async function logout() {
    // 不退出native登录
    return true;
  };

  return MTLiveAnchor;
}(MeiTuanMerchant);

var mw$1 = async function mw(ctx, next) {
  var clientType = ctx.clientType;

  if (CLIENT_TYPE.mtliveanchor === clientType) {
    return new MTLiveAnchor();
  }

  return next();
};

/**
 * SSR
 */

var SSR = /*#__PURE__*/function (_Account) {
  _inheritsLoose(SSR, _Account);

  function SSR() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Account.call.apply(_Account, [this].concat(args)) || this;
    _this.className = "SSR";
    return _this;
  }

  var _proto = SSR.prototype;

  _proto.resloveToken = async function resloveToken() {
    console.log('resloveToken 暂不支持 Node 环境');
    return;
  };

  _proto.getLoginUrl = function getLoginUrl(_option) {
    console.log('getLoginUrl 暂不支持 Node 环境');
    return '';
  };

  _proto.login = function login(_option) {
    console.log('Node 环境不需要登录');
  };

  return SSR;
}(Account$1);

var mw = async function mw(_ctx, next) {
  if (!isBrowser) {
    return new SSR();
  }

  return next();
};

var defaultAdapters = [mw, mw$3, mw$4, mw$5, mw$6, mw$1, mw$7, mw$2];

var ELogin = /*#__PURE__*/function (_Login) {
  _inheritsLoose(ELogin, _Login);

  function ELogin() {
    var _this;

    _this = _Login.call(this, ENU_CAP_LOGIN_TYPE.EPASSPORT) || this; // 初始化默认适配对象

    _this.adapter = new Account$1();

    _this.adapterManager.use(defaultAdapters);

    return _this;
  }
  /**
   * 服务初始化
   * @param options LoginOption
   * @param options.env RUNTIME_ENV 运行时环境，与美团各环境保持一致（local、dev、test、staging、production）。必填，默认：production
   * @param options.backUrl string 登录或退出后默认的回跳地址。默认：location.href
   * @param options.appKey 申请接入Epassport的appkey，B端登录必传appkey 。sdk已内置：com.sankuai.fspfecap.bizcommon. 详见：@see https://km.sankuai.com/page/21599502#id-2.1.2query%E5%8F%82%E6%95%B0%E8%AF%B4%E6%98%8E
   * @returns ELogin
   */


  var _proto = ELogin.prototype;

  _proto.init = async function init(options) {
    var _this2 = this;

    if (options === void 0) {
      options = {};
    }

    this.optsions = _objectSpread(_objectSpread({}, this.optsions), options);
    var _this$optsions = this.optsions,
        bizline = _this$optsions.bizline,
        sameSite = _this$optsions.sameSite,
        setLoginTypeToCookie = _this$optsions.setLoginTypeToCookie,
        apiTimeout = _this$optsions.apiTimeout,
        bomCtx = _this$optsions.bomCtx;
    this.bizline = bizline;
    var ua = bomCtx == null ? void 0 : bomCtx.userAgent;
    var clientType = getClientTypeSync(ua);
    var ctx = {
      ua: ua,
      clientType: clientType
    };
    var cookieOption = {};

    if (sameSite === false) {
      cookieOption.sameSite = 'None';
      cookieOption.secure = true;
    } // 配置了api超时时间的需要使用项目配置的超时时间配置


    if (apiTimeout) {
      this.apiManager.setHttpTimeout(apiTimeout);
    } // 种植登录类型


    Cookies.set('cap_login_type', this.capLoginType, cookieOption);
    var adapter = await this.adapterManager.dispatch(ctx); // 获取到有效adapter，则覆盖默认account adapter

    if (adapter) {
      this.adapter = adapter;
    }

    try {
      var token = await this.adapter.resloveToken();

      if (token) {
        Cookies.set('epassport_token', token, _objectSpread(_objectSpread({}, cookieOption), {}, {
          domain: getCookieDomain()
        }));
      }

      await this.apiManager.auth({
        token: token,
        clientType: clientType,
        sameSite: sameSite,
        bizline: bizline,
        loginTypeToCookie: setLoginTypeToCookie
      }).then(function (ret) {
        if (ret) {
          return _this2.getUserInfo(true);
        }

        return null;
      });
    } catch (error) {
      var _this$optsions$bomCtx = this.optsions.bomCtx,
          origin = _this$optsions$bomCtx.origin,
          pathname = _this$optsions$bomCtx.pathname;
      reportError('B端登录sdk初始化失败.p3', error, {
        tags: {
          clientType: clientType,
          href: "" + origin + pathname
        }
      });
      console.log('elogin init error.', error);
    }

    return this;
  };

  return ELogin;
}(Login);

var eLogin = new ELogin();

export { Account$2 as Account, Account$1 as ELoginBaseAccount, ENU_CAP_LOGIN_TYPE, ENU_LOGIN_SENCE, ENU_STATUS_CODE, Account as ILoginBaseAccount, Login, RUNTIME_ENV, SET_TOKEN_URL, USER_TYPE, defaultUrl, eLogin, getCookieDomain, iLogin, loadKNB, loginConfig, reportError };
